export default function addEventListenerDomUtil (event, handler) {
  window.addEventListener(event, handler)
}
